// Источник: агрегированный справочник городов по регионам РФ
// Формат: { "ФО": { "Регион": ["Город1", "Город2", ...], ... }, ... }

export const citiesByRegions = {
    "Центральный федеральный округ": {
      "Москва и Московская область": [
        "Москва",
        "Балашиха",
        "Домодедово",
        "Ногинск",
        "Щёлково",
        "Красногорск",
        "Реутов",
        "Раменское",
        "Мытищи",
        "Люберцы",
        "Пушкино",
        "Долгопрудный",
        "Воскресенск",
        "Коломна",
        "Дубна",
        "Королёв",
        "Павловский Посад",
        "Лобня",
        "Власиха",
        "Можайск",
        "Лосино-Петровский",
        "Жуковский",
        "Серпухов",
        "Подольск",
        "Солнечногорск",
        "Тучково",
        "Нахабино",
        "Одинцово",
        "Наро-Фоминск",
        "Томилино",
        "Талдом",
        "Жаворонки",
        "Дорохово",
        "Железнодорожный",
        "Лыткарино",
        "Химки",
        "Дорогомилово",
        "Троицк",
        "Электросталь",
        "Фрязино",
        "Электрогорск",
        "Протвино",
        "Дзержинский",
        "Монино",
        "Хотьково",
        "Свердловский",
        "Видное",
        "Салтыковка",
        "Звенигород",
        "Малаховка",
        "Замоскворечье",
        "Черноголовка",
        "Старая Купавна",
        "Зарайск",
        "Немчиновка",
        "Егорьевск",
        "Истра",
        "Зеленоград",
        "Софрино",
        "Красноармейск",
        "Петровско-Разумовское",
        "Пресненский",
        "Ступино",
        "Климовск",
        "Орехово-Зуево",
        "Загорские Дали",
        "Кубинка",
        "Поварово",
        "Запрудня",
        "Булгаково"
      ],
      "Белгородская область": [
        "Белгород",
        "Старый Оскол",
        "Губкин",
        "Алексеевка",
        "Валуйки",
        "Строитель",
        "Короча",
        "Волоконовка",
        "Вейделевка",
        "Майский"
      ],
      "Брянская область": [
        "Брянск",
        "Клинцы",
        "Сельцо",
        "Унеча",
        "Фокино",
        "Трубчевск"
      ],
      "Владимирская область": [
        "Владимир",
        "Ковров",
        "Александров",
        "Кольчугино",
        "Карабаново",
        "Петушки",
        "Гусь-Хрустальный",
        "Муром",
        "Вязники",
        "Небылое",
        "Струнино",
        "Киржач",
        "Новлянка"
      ],
      "Воронежская область": [
        "Воронеж",
        "Борисоглебск",
        "Лиски"
      ],
      "Ивановская область": [
        "Иваново",
        "Нерль",
        "Фурманов",
        "Родники",
        "Шуя",
        "Приволжск",
        "Старая Вичуга"
      ],
      "Калужская область": [
        "Калуга",
        "Обнинск",
        "Сухиничи"
      ],
      "Костромская область": [
        "Кострома",
        "Буй",
        "Галич",
        "Нерехта"
      ],
      "Курская область": [
        "Курск",
        "Железногорск",
        "Лука Осиповка",
        "Курчатов",
        "Щигры"
      ],
      "Липецкая область": [
        "Липецк",
        "Елец"
      ],
      "Орловская область": [
        "Орёл",
        "Ливны"
      ],
      "Рязанская область": [
        "Рязань",
        "Сасово",
        "Скопин"
      ],
      "Смоленская область": [
        "Смоленск",
        "Сафоново",
        "Ярцево",
        "Десногорск",
        "Ельня",
        "Рославль"
      ],
      "Тамбовская область": [
        "Тамбов",
        "Моршанск",
        "Мичуринск",
        "Уварово",
        "Кирсанов",
        "Дмитриевка",
        "Жердевка"
      ],
      "Тверская область": [
        "Тверь",
        "Ржев",
        "Торжок",
        "Кимры",
        "Конаково",
        "Бежецк",
        "Нелидово",
        "Удомля",
        "Редкино",
        "Белый"
      ],
      "Тульская область": [
        "Тула",
        "Новомосковск",
        "Узловая",
        "Богородицк",
        "Донской",
        "Ясногорск"
      ],
      "Ярославская область": [
        "Ярославль",
        "Рыбинск",
        "Углич",
        "Гаврилов-Ям",
        "Ростов Великий",
        "Любим",
        "Тутаев"
      ]
    },
    "Северо-Западный федеральный округ": {
      "Санкт-Петербург и Ленинградская область": [
        "Санкт-Петербург",
        "Тихвин",
        "Кингисепп",
        "Мурино",
        "Автово",
        "Кириши",
        "Выборг",
        "Лодейное Поле",
        "Сестрорецк",
        "Гатчина",
        "Царское Село",
        "Кушелевка",
        "Ивангород",
        "Волхов",
        "Пикалёво",
        "Лесной",
        "Зеленогорск" ,
        "Приозерск",
        "Бугры",
        "Красный Бор",
        "Парголово",
        "Пудомяги",
        "Яблоницы",
        "Новая Голландия",
        "Отрадное",
        "Луга",
        "Коммунар",
        "Волховский",
        "Юдино"
        
      ],
      "Архангельская область": [
        "Архангельск",
        "Северодвинск",
        "Котлас",
        "Коряжма",
        "Вельск",
        "Коноша"
        
      ],
      "Вологодская область": [
        "Вологда",
        "Череповец",
        "Сокол",
        "Шексна",
        "Устюжна",
        "Вожега",
        "Никольск"
      ],
      "Калининградская область": [
        "Калининград",
        "Балтийск",
        "Гусев",
        "Советск",
        "Неман",
        "Пионерский",
        "Светлый",
        "Гурьевск",
        "Зеленоградск"
      ],
      "Республика Карелия": [
        "Петрозаводск",
        "Кемь",
        "Сегежа",
        "Костомукша",
        "Кончезеро"
      ],
      "Республика Коми": [
        "Сыктывкар",
        "Ухта",
        "Воркута",
        "Троицко-Печорск",
        "Усинск",
        "Инта"
      ],
      "Мурманская область": [
        "Мурманск",
        "Североморск",
        "Кандалакша",
        "Апатиты",
        "Мончегорск",
        "Кировск",
        "Видяево"
      ],
      "Ненецкий АО": [
        "Нарьян-Мар"
      ],
      "Новгородская область": [
        "Великий Новгород",
        "Боровичи"
      ],
      "Псковская область": [
        "Псков",
        "Рубилово",
        "Великие Луки",
        "Невель"
      ]
    },
    "Южный федеральный округ": {
      "Ростовская область": [
        "Ростов-на-Дону",
        "Таганрог",
        "Волгодонск",
        "Новочеркасск",
        "Шахты",
        "Каменск-Шахтинский",
        "Аксай",
        "Азов",
        "Батайск",
        "Новошахтинск",
        "Морозовск",
        "Калач-на-Дону",
        "Зерноград",
        "Чалтырь",
        "Багаевская",
        "Тацинский"
      ],
      
      "Краснодарский край": [
        "Краснодар",
        "Сочи",
        "Новороссийск",
        "Армавир",
        "Анапа",
        "Крымск",
        "Туапсе",
        "Геленджик",
        "Каневская",
        "Тихорецк",
        "Анапская",
        "Славянск-на-Кубани",
        "Абинск",
        "Новотитаровская",
        "Приморско-Ахтарск",
        "Брюховецкая",
        "Кореновск",
        "Кропоткин",
        "Апшеронск",
        "Выселки",
        "Афипский",
        "Белореченск",
        "Новокубанск",
        "Павловская",
        "Старонижестеблиевская",
        "Старотитаровская",
        "Темрюк",
        "Шепси",
        "Ленинградская"
      ],
      "Волгоградская область": [
        "Волгоград",
        "Волжский",
        "Камышин",
        "Куйбышев",
        "Михайловка"
      ],
      "Астраханская область": [
        "Астрахань"
      ],
      "Республика Адыгея": [
        "Майкоп",
        "Яблоновский",
        "Новая Адыгея",
        "Энем"
  
      ],
      "Республика Калмыкия": [
        "Элиста"
      ],
      "Республика Крым": [
        "Симферополь"
      ]
    },
    "Северо-Кавказский федеральный округ": {
      "Ставропольский край": [
        "Ставрополь",
        "Пятигорск",
        "Кисловодск",
        "Ессентуки",
        "Железноводский",
        "Невинномысск",
        "Изобильный",
        "Благодарный",
        "Лермонтов",
        "Ессентукская"
      ],
      "Республика Дагестан": [
        "Махачкала",
        "Буйнакск",
        "Кизляр",
        "Каспийск",
        "Хасавюрт",
        "Дербент",
        "Избербаш",
        "Кизилюрт",
        "Коркмаскала",
        "Кочубей",
        "Кемсиюрт"
      ],
      "Кабардино-Балкарская Республика": [
        "Нальчик"
      ],
      "Карачаево-Черкесская Республика": [
        "Черкесск"
      ],
      "Республика Северная Осетия-Алания": [
        "Владикавказ",
        "Дигора"
      ],
      "Республика Ингушетия": [
        "Назрань",
        "Карабулак",
        "Экажево"
      ],
      "Чеченская Республика": [
        "Грозный"
      ],
      "Донецкая Народная Республика": [
        "Донецк"
      ]
    },
    "Приволжский федеральный округ": {
      "Нижегородская область": [
        "Нижний Новгород",
        "Дзержинск",
        "Арзамас",
        "Саров",
        "Каликино",
        "Бор",
        "Ардатов",
        "Кстово",
        "Городец",
        "Выкса",
        "Княгинино",
        "Богородск"
      ],
      "Республика Татарстан": [
        "Казань",
        "Набережные Челны",
        "Нижнекамск",
        "Альметьевск",
        "Бугульма",
        "Лениногорск",
        "Елабуга",
        "Заинск",
        "Актаныш",
        "Азнакаево",
        "Джалиль",
         "Старые Матаки"
      ],
      "Самарская область": [
        "Самара",
        "Тольятти",
        "Новокуйбышевск",
        "Жигулёвск",
        "Нефтегорск",
        "Шигоны",
        "Октябрьск"
      ],
      "Республика Башкортостан": [
        "Уфа",
        "Стерлитамак",
        "Нефтекамск",
        "Салават",
        "Белорецк",
        "Кумертау",
        "Туймазы",
        "Сибай",
        "Ишимбай",
        "Мелеуз",
        "Белебей",
        "Дюртюли",
        "Учалы",
        "Благовар",
        "Приютово",
        "Бирск",
        "Раевский"
      ],
      "Пермский край": [
        "Пермь",
        "Соликамск",
        "Чайковский",
        "Кудымкар",
        "Горнозаводск",
        "Лысьва",
        "Березники",
        "Краснокамск",
        "Чусовой",
        "Губаха",
        "Добрянка"
      ],
      "Оренбургская область": [
        "Оренбург",
        "Орск",
        "Новотроицк",
        "Бузулук",
        "Саракташ",
        "Бугуруслан"
      ],
      "Саратовская область": [
        "Саратов",
        "Энгельс",
        "Балаково",
        "Вольск"
      ],
      "Ульяновская область": [
        "Ульяновск"
      ],
      "Пензенская область": [
        "Пенза",
        "Кузнецк",
        "Сердобск",
        "Мокшан"
      ],
      "Республика Мордовия": [
        "Саранск",
        "Ардатов",
        "Мордово"
      ],
      "Республика Марий Эл": [
        "Йошкар-Ола",
        "Волжск"
      ],
      "Удмуртская Республика": [
        "Ижевск",
        "Воткинск",
        "Глазов",
        "Можга",
        "Балезино",
        "Камбарка"
      ],
      "Чувашская Республика": [
        "Чебоксары",
        "Новочебоксарск",
        "Шумерля",
        "Алатырь"
      ],
      "Кировская область": [
        "Киров",
        "Емельяново", 
        "Омутнинск"
      ]
    },
    "Уральский федеральный округ": {
      "Свердловская область": [
        "Екатеринбург",
        "Нижний Тагил",
        "Каменск-Уральский",
        "Первоуральск",
        "Новоуральск",
        "Реж",
        "Асбест",
        "Серов",
        "Краснотурьинск",
        "Невьянск",
        "Верхняя Пышма",
        "Арамиль",
        "Белоярский",
        "Алапаевск",
        "Среднеуральск",
        "Артёмовский",
        "Ревда",
        "Нижняя Тура",
        "Кушва",
        "Карпинск",
        "Станционный-Полевской",
        "Рефтинский",
        "Кировград",
        "Бисерть"
      ],
      "Челябинская область": [
        "Челябинск",
        "Магнитогорск",
        "Златоуст",
        "Миасс",
        "Снежинск",
        "Озёрск",
        "Троицк",
        "Сатка",
        "Еманжелинск",
        "Коркино",
        "Усть-Катав",
        "Пласт",
        "Карталы",
        "Аргаяш",
        "Канашево"
      ],
      "Тюменская область": [
        "Тюмень",
        "Тобольск",
        "Ишим",
        "Заводоуковск"
      ],
      "Ханты-Мансийский автономный округ": [
        "Сургут",
        "Нижневартовск",
        "Нефтеюганск",
        "Когалым",
        "Нягань",
        "Пыть-Ях",
        "Урай",
        "Ванзeтур",
        "Югорск",
        "Радужный",
        "Советский",
        "Мегион",
        "Горноправдинск",
        "Октябрьское"
      ],
      "Ямало-Ненецкий автономный округ": [
        "Новый Уренгой",
        "Ноябрьск",
        "Салехард",
        "Надым",
        "Тарко-Сале"
      ],
      "Курганская область": [
        "Курган",
        "Шадринск"
      ]
    },
    "Сибирский федеральный округ": {
      "Новосибирская область": [
        "Новосибирск",
        "Бердск",
        "Искитим",
        "Краснообск",
        "Болотное",
        "Коченёво",
        "Мочищи",
        "Чулым"
      ],
      "Красноярский край": [
        "Красноярск",
        "Норильск",
        "Ачинск",
        "Канск",
        "Минусинск",
        "Железногорск",
        "Зеленогорск",
        "Дивногорск",
        "Шарыпово",
        "Назарово",
        "Сосновоборск",
        "Уяр",
        "Абан",
        "Иланский",
        "Туруханск",
        "Заозёрный"
      ],
      "Иркутская область": [
        "Иркутск",
        "Братск",
        "Ангарск",
        "Усть-Илимск",
        "Черемхово",
        "Усолье-Сибирское",
        "Тулун",
        "Зима",
        "Новая Игирма",
        "Саянское",
        "Шелехов",
        "Тайшет",
        "Нижнеудинск",
        "Киренск",
        "Бодайбо",
        "Железногорск-Илимский",
        "Усть-Кут",
        "Вихоревка",
        "Слюдянка",
        "Тайтурка",
        "Улькан",
        "Магистральный",
        "Луговский",
        "Гора Синюшина"
      ],
      "Кемеровская область": [
        "Кемерово",
        "Новокузнецк",
        "Прокопьевск",
        "Междуреченск",
        "Ленинск-Кузнецкий",
        "Киселёвск",
        "Белово",
        "Анжеро-Судженск",
        "Топки",
        "Мыски",
        "Мариинск",
        "Гурьевск"
      ],
      "Томская область": [
        "Томск",
        "Северск",
        "Стрежевой",
        "Асино"
      ],
      "Омская область": [
        "Омск"
      ],
      "Алтайский край": [
        "Барнаул",
        "Бийск",
        "Рубцовск",
        "Новоалтайск",
        "Заринск",
        "Алейск",
        "Камень-на-Оби"
      ],
      "Республика Алтай": [
        "Горно-Алтайск",
        "Турочак"
      ],
      "Республика Тыва": [
        "Кызыл",
        "Шагонар"
      ],
      "Республика Хакасия": [
        "Абакан",
        "Черногорск",
        "Саяногорск", 
        "Сорск"
      ],
      "Забайкальский край": [
        "Чита",
        "Краснокаменск",
        "Агинское",
        "Вершино-Дарасунский",
        "Могойтуй",
        "Новая Чара"
      ],
      "Республика Бурятия": [
        "Улан-Удэ",
        "Северобайкальск",
        "Гусиноозёрск",
        "Мухор-Шибирь",
        "Нижнеангарск"
      ]
    },
    "Дальневосточный федеральный округ": {
      "Хабаровский край": [
        "Хабаровск",
        "Комсомольск-на-Амуре",
        "Амурск",
        "Ванино",
        "Бикин",
        "Переяславка"
      ],
      "Приморский край": [
        "Владивосток",
        "Находка",
        "Уссурийск",
        "Артём",
        "Арсеньев",
        "Партизанск",
        "Дальнегорск",
        "Лучегорск",
        "Славянка"
      ],
      "Амурская область": [
        "Благовещенск",
        "Свободный",
        "Тында"
      ],
      "Сахалинская область": [
        "Южно-Сахалинск",
        "Корсаков",
        "Холмск",
        "Оха",
        "Ноглики",
        "Поронайск",
        "Невельск",
        "Шахтёрск"
      ],
      "Камчатский край": [
        "Петропавловск-Камчатский",
        "Елизово",
        "Вилючинск"
      ],
      "Магаданская область": [
        "Магадан"
      ],
      "Республика Саха (Якутия)": [
        "Якутск",
        "Нерюнгри",
        "Ленск",
        "Майя",
        "Батамай"
      ],
      "Чукотский автономный округ": [],
      "Еврейская автономная область": [
        "Биробиджан",
        "Смидович"
      ]
    }
};
